import React, { memo } from 'react';
import LeafHeader from './leafHeader';

const AddBtn = ({ onClick }) => (
  <div className="add-btn" onClick={onClick}>
    <span className="appkiticon icon-plus-fill" />
  </div>
);

function TreeAddNode(props) {
  const { className, order, isExpand } = props;

  const { handleToggleExpand, onAddNode } = props;

  return (
    <>
      <div className={`lifecycle-content  ${className}`}>
        <div className="lifecycle-add-node">
          <LeafHeader
            title={<AddBtn onClick={onAddNode} />}
            hasArrow={false}
            isExpand={isExpand}
            onExpand={handleToggleExpand}
            order={order + 1}
          />
        </div>
      </div>
    </>
  );
}

TreeAddNode.propTypes = {};

export default memo(TreeAddNode);
